import { IStoreRootState } from "./interface";

export default <IStoreRootState> {

}